// src/api/ticketApi.js
import apiClient from "./axios";

const ticketApi = {
  // // GET all tickets (with pagination + search)
  // getAll: async (page = 1, pageSize = 10, search = "") => {
  //   const response = await apiClient.get("/tickets/", {
  //     params: { page, page_size: pageSize, search },
  //   });
  //   return response.data;
  // },

  // src/api/ticketApi.js - UPDATE the getAll method:

getAll: async (page = 1, pageSize = 10, search = '', createdBy = null, assignedTo = null) => {
  const params = { page, page_size: pageSize, search };
  
  // Add filters only if they have values
  if (createdBy && createdBy !== 'all') {
    params.created_by = createdBy;
  }
  if (assignedTo && assignedTo !== 'all') {
    params.assigned_to = assignedTo;
  }
  
  const response = await apiClient.get('/tickets/', { params });
  return response.data;
},

  // GET single ticket
  getById: async (id) => {
    const response = await apiClient.get(`/tickets/${id}/`);
    return response.data;
  },

  // CREATE ticket
  create: async (data) => {
    const response = await apiClient.post("/tickets/", data);
    return response.data;
  },

  // UPDATE ticket (PATCH)
  update: async (id, data) => {
    const response = await apiClient.patch(`/tickets/${id}/`, data);
    return response.data;
  },

  // DELETE ticket
  delete: async (id) => {
    await apiClient.delete(`/tickets/${id}/`);
    return id;
  },

  // Status actions
  inProgress: async (id) => {
    await apiClient.post(`/tickets/${id}/in-progress/`);
  },
  close: async (id) => {
    await apiClient.post(`/tickets/${id}/close/`);
  },
  reopen: async (id) => {
    await apiClient.post(`/tickets/${id}/reopen/`);
  },
  // resolve: async (id) => {
  //   await apiClient.post(`/tickets/${id}/resolved/`);
  // },

  // Update the resolve method in ticketApi.js
  resolve: async (id, resolved_remark) => {
    const response = await apiClient.post(`/tickets/${id}/resolved/`, {
      resolved_remark,
    });
    return response.data;
  },

  acknowledge: async (id, data) => {
    await apiClient.post(`/tickets/${id}/acknowledge/`, data);
  },

  // Messages
  getMessages: async (ticketId) => {
    const response = await apiClient.get(`/tickets/${ticketId}/messages/`);
    return response.data;
  },
  sendMessage: async (ticketId, message) => {
    const response = await apiClient.post(`/tickets/${ticketId}/messages/`, {
      message,
    });
    return response.data;
  },
  updateMessage: async (ticketId, messageId, message) => {
    const response = await apiClient.patch(
      `/tickets/${ticketId}/messages/${messageId}/`,
      { message }
    );
    return response.data;
  },
  deleteMessage: async (ticketId, messageId) => {
    await apiClient.delete(`/tickets/${ticketId}/messages/${messageId}/`);
  },

  // SUBCATEGORIES — IT & NON-IT
  getCategories: async () => {
    const response = await apiClient.get("/categories/inventory/");
    return response.data;
  },

  // SUBCATEGORIES — IT & NON-IT (Now accepts categoryId)
  getITSubcategories: async (categoryId = null) => {
    const params = categoryId ? { category: categoryId } : {};
    const response = await apiClient.get("/subcategories/it/", { params });
    return response.data;
  },

  getNonITSubcategories: async (categoryId = null) => {
    const params = categoryId ? { category: categoryId } : {};
    const response = await apiClient.get("/subcategories/non_it/", { params });
    return response.data;
  },
};

export default ticketApi;
